<template>
  <div></div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import eventBus from "../eventBus";

export default {
  name: "callback",
  created() {
    //get Token from URL after page loaded
    let uri = window.location.href.split("#");
    let tokens = {};
    let tmp = "";
    let payload = "";

    if (uri.length == 2) {
      let vars = uri[1].split("&");

      //enumerate parameters
      vars.forEach(function(v) {
        tmp = v.split("=");
        if (tmp.length == 2) tokens[tmp[0]] = tmp[1];
      });
    }

    if (tokens && tokens.access_token && tokens.id_token) {
      // valid token
      this.$store.dispatch("cognito/setToken", [
        tokens.id_token,
        tokens.access_token
      ]);
      payload = this.$store.getters["cognito/getPayload"]();
      eventBus.$emit("TOKEN_UPDATED", payload);
      this.$router.push("/portfolio"); //redirect to secure page
    } else {
      //invalid token
      this.$store.dispatch("cognito/removeToken");
      eventBus.$emit("TOKEN_REMOVED", {});
      this.$router.push("/"); //redirect to main page
    }
  },
  computed: {
    ...mapGetters(["cognito/getPayload"])
  },
  methods: {
    ...mapActions(["cognito/setToken", "cognito/removeToken"])
  }
};
</script>
